import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import { useLanguage } from "../../context/LanguageContext";
import { getSkridblatnirTranslations } from "../../translations/skridblatnirTemplate";
import { isMobileOrTablet } from "../../utils/appUtils";
import { isMobile } from "../../utils/appUtils";
import { useEditMode } from "../../context/EditModeContext";
import EditableText from "../../components/EditableText/EditableText";
import { usePageContent } from "../../hooks/usePageContent";
import { SkridblatnirTranslations } from "../../translations/skridblatnirTemplate";

function Skridblatnir() {
    const { language } = useLanguage();
    const { isEditMode } = useEditMode();
    const { content, loading } = usePageContent<SkridblatnirTranslations>('skridblatnir');

    // Use translations as fallback content
    const t = content || getSkridblatnirTranslations(language);

    // Show loading state if needed
    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin h-12 w-12 border-2 border-gray-400 rounded-full border-t-transparent"></div>
            </div>
        );
    }

    return (
        <div className="">
            <BackgroundCover
                backgroundHeight={isMobileOrTablet() ? (isMobile() ? 400 : 600) : undefined}
                imagePosition={isMobileOrTablet() ? (isMobile() ? "center" : "initial") : "initial"} 
                backgroundImage="/images/skridblatnir/skridblatnir_bg.jpg"
            >
                <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
                    <Title
                        firstLine={isEditMode ? (
                            <EditableText
                                contentKey="skridblatnir.title.firstLine"
                                defaultValue={t.title.firstLine}
                            />
                        ) : t.title.firstLine}
                        secondLine={isEditMode ? (
                            <EditableText
                                contentKey="skridblatnir.title.secondLine"
                                defaultValue={t.title.secondLine}
                            />
                        ) : t.title.secondLine}
                        className="hidden md:block text-white"
                        animate={true}
                    />
                </div>
            </BackgroundCover>

            <div className="mx-auto px-4 py-6 md:py-24">
                <div className="block md:hidden mb-8">
                    <Title
                        firstLine={isEditMode ? (
                            <EditableText
                                contentKey="skridblatnir.title.firstLine"
                                defaultValue={t.title.firstLine}
                            />
                        ) : t.title.firstLine}
                        secondLine={isEditMode ? (
                            <EditableText
                                contentKey="skridblatnir.title.secondLine"
                                defaultValue={t.title.secondLine}
                            />
                        ) : t.title.secondLine}
                        className=""
                        animate={true}
                    />
                </div>
                <div className="flex flex-col items-center">
                    <div className="max-w-4xl text-sm text-gray-600 leading-relaxed">
                        {isEditMode ? (
                            <EditableText
                                contentKey="skridblatnir.introduction"
                                defaultValue={t.introduction}
                                multiline={true}
                            />
                        ) : t.introduction}
                    </div>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] pb-12 md:py-12">
                    <div className="mx-auto px-4 md:px-12 lg:pt-8 max-w-7xl">
                        {t.sections.map((section, index) => (
                            <TimelineSection
                                key={index}
                                title={{
                                    firstLine: " ",
                                    secondLine: " ",
                                }}
                                description={isEditMode ? (
                                    <EditableText
                                        contentKey={`skridblatnir.sections.${index}.description`}
                                        defaultValue={section.description}
                                        multiline={true}
                                    />
                                ) : section.description}
                                media={{
                                    type: 'image',
                                    src: `/images/skridblatnir/Skridblatnir_${index + 1}.jpg`,
                                    alt: `Skridblatnir Ship Page ${index + 1}`
                                }}
                                mediaPosition={index % 2 === 0 ? "right" : "left"}
                                showLine={index !== t.sections.length - 1}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skridblatnir; 